import React, { useState, useEffect } from "react";
import axios from "axios";

const Products = () => {
  const [product, setProduct] = useState([]);

  useEffect(() => {
    getAllProducts();
  }, []);

  const getAllProducts = async (e) => {
    try {
      const response = await axios.get(
        `${process.env.REACT_APP_SERVER}product`
      );
      // console.log(response);
      setProduct(response.data.products);
    } catch (error) {
      console.log(error);
    }
  };

  return (
    <section id="product" className="pt-24  pb-2 md:pt-16 md:mt-16">
      <div className="mx-auto container">
        <div
          className="w-full text-slate-800 md:mx-10 px-6 md:px-20"
          data-aos="fade-left"
          data-aos-duration="800"
        >
          <h3 className="font-poppins text-3xl md:text-3xl font-medium  border-l-4 border-secondary pl-4">
            Produk <span className="text-secondary"> Kami</span>
          </h3>
          <p className="font-poppins font-light text-slate-500 text-sm mt-4">
            Berbagai macam produk kami sediakan untuk anda
          </p>
        </div>
        <div
          className="mx-4 mt-8 md:px-8 flex flex-wrap gap-4  justify-center cursor-pointer"
          data-aos="flip-right"
          data-aos-duration="800"
        >
          {product.map((prd, i) => (
            <div
              key={i}
              className="w-[47%] md:w-[18%] md:mx-4 hover:-translate-y-2 transition duration-200"
            >
              <div className="h-[168px] md:h-[225px] shadow-sm rounded-2xl bg-slate-800 overflow-hidden hover:shadow-xl transition duration-200">
                <img src={prd.url} className="w-full h-full" />
              </div>
              <p className="w-full text-center mt-4 text-slate-800 font-poppins font-semibold">
                {prd.name}
              </p>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
};

export default Products;
